import { GaleriaVehiculoComponent } from './components/popups/vehiculos/galeria-vehiculo/galeria-vehiculo.component';
import { HistorialVelocidadesVehiculoComponent } from './components/popups/vehiculos/historial-velocidades-vehiculo/historial-velocidades-vehiculo.component';
import { PasoPuntoVehiculoComponent } from './components/popups/vehiculos/paso-punto-vehiculo/paso-punto-vehiculo.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { GaugeChartModule } from 'angular-gauge-chart';
import { MatCardModule } from '@angular/material/card';
import { GoogleChartsModule } from 'angular-google-charts';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './../../shared_modules/shared.module';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule, MatListModule } from '@angular/material';
import { DxButtonModule, DxTemplateModule, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTreeListModule, DxFormModule, DxPopupModule, DxPopoverModule, DxDateBoxModule, DxLoadPanelModule, DxValidationGroupModule, DxValidatorModule, DxTagBoxModule, DxCircularGaugeModule, DxLinearGaugeModule, DxChartModule, DxTabPanelModule, DxTabsModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { MonitoreoRoutingModule } from './monitoreo-routing.module';
import { MonitoreoComponent } from './monitoreo.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { InformacionVehiculoComponent } from './components/popups/vehiculos/informacion-vehiculo/informacion-vehiculo.component';
import { HistoricoPosicionesVehiculoComponent } from './components/popups/vehiculos/historico-posiciones-vehiculo/historico-posiciones-vehiculo.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { GraficaEstadisticaVehiculoComponent } from './components/popups/vehiculos/historico-posiciones-vehiculo/grafica-estadistica-vehiculo/grafica-estadistica-vehiculo.component';
import { InformacionMedidorComponent } from './components/popups/medidores/informacion-medidor/informacion-medidor.component';
import { StreetViewComponent } from './components/popups/street-view/street-view.component';
import { HistoricoPosicionesMedidorComponent } from './components/popups/medidores/historico-posiciones-medidor/historico-posiciones-medidor.component';
import { GraficaEstadisticaMedidorComponent } from './components/popups/medidores/historico-posiciones-medidor/grafica-estadistica-medidor/grafica-estadistica-medidor.component';
import { InformacionMicromedidorComponent } from './components/popups/micromedidores/informacion-micromedidor/informacion-micromedidor.component';
import { VehiculoModalComponent } from './components/dialogos/vehiculos/vehiculo-modal/vehiculo-modal.component';
import { VehiculoUltimaTransmisionComponent } from './components/dialogos/vehiculos/vehiculo-ultima-transmision/vehiculo-ultima-transmision.component';
import { MedidorModalComponent } from './components/dialogos/medidores/medidor-modal/medidor-modal.component';
import { MedidorUltimaTransmisionComponent } from './components/dialogos/medidores/medidor-ultima-transmision/medidor-ultima-transmision.component';
import { MicromedidorModalComponent } from './components/dialogos/micromedidores/micromedidor-modal/micromedidor-modal.component';
import { MicromedidorUltimaTransmisionComponent } from './components/dialogos/micromedidores/micromedidor-ultima-transmision/micromedidor-ultima-transmision.component';
import { GuardarGeocercaComponent } from './components/dialogos/geocercas/guardar-geocerca/guardar-geocerca.component';
import { GeocercaModalComponent } from './components/dialogos/geocercas/geocerca-modal/geocerca-modal.component';
import { PuntosInteresModalComponent } from './components/dialogos/puntos-interes/puntos-interes-modal/puntos-interes-modal.component';
import { GuardarPuntoInteresComponent } from './components/dialogos/puntos-interes/guardar-punto-interes/guardar-punto-interes.component';
import { SemaforoModalComponent } from './components/dialogos/semaforo/semaforo-modal/semaforo-modal.component';
import { InformacionActivoComponent } from './components/popups/activos/informacion-activo/informacion-activo.component';
import { HistoricoPosicionesActivoComponent } from './components/popups/activos/historico-posiciones-activo/historico-posiciones-activo.component';
import { ActivoModalComponent } from './components/dialogos/activos/activo-modal/activo-modal.component';
import { ActivoUltimaTransmisionComponent } from './components/dialogos/activos/activo-ultima-transmision/activo-ultima-transmision.component';
import { TelefonoModalComponent } from './components/dialogos/telefonos/telefono-modal/telefono-modal.component';
import { TelefonoUltimaTransmisionComponent } from './components/dialogos/telefonos/telefono-ultima-transmision/telefono-ultima-transmision.component';
import { HistoricoPosicionesTelefonoComponent } from './components/popups/telefonos/historico-posiciones-telefono/historico-posiciones-telefono.component';
import { InformacionTelefonoComponent } from './components/popups/telefonos/informacion-telefono/informacion-telefono.component';
import { AlertasComponent } from './components/dialogos/alertas/alertas.component';
import { GaleriaVideosComponent } from './components/popups/vehiculos/galeria-videos/galeria-videos.component';
import { SafeUrlPipe } from './components/popups/vehiculos/galeria-videos/safe-url.pipe';
import { PasoPuntoComponent } from './components/dialogos/vehiculos/paso-punto/paso-punto.component';
import { DentroGeocercaComponent } from './components/popups/vehiculos/dentro-geocerca/dentro-geocerca.component';
import { FueraGeocercaComponent } from './components/popups/vehiculos/fuera-geocerca/fuera-geocerca.component';
import { DentroGeocercaModalComponent } from './components/dialogos/vehiculos/dentro-geocerca-modal/dentro-geocerca-modal.component';
import { MapaMarkerComponent } from './components/mapa-marker/mapa-marker.component';
import { PlayVideoComponent } from './components/popups/vehiculos/galeria-videos/play-video/play-video.component';
import { StreamVideoComponent } from './components/popups/vehiculos/galeria-videos/stream-video/stream-video.component';
import { ReutilizablesModule } from '../reutilizables/reutilizables.module';
import { PopupRecorridoHistoricoComponent } from './components/popups/popup-recorrido-historico/popup-recorrido-historico.component';
import { HistoricoMedicionesMicromedidorComponent } from './components/popups/micromedidores/historico-mediciones-micromedidor/historico-mediciones-micromedidor.component';
import { CategoriasComponent } from './components/dialogos/geocercas/categorias/categorias.component';
import { ReproduccionComponent } from './components/popups/vehiculos/reproduccion/reproduccion.component';
import { FiltroProductosComponent } from './components/dialogos/filtro-productos/filtro-productos.component';
import { GaleriaNuevoDispositivoComponent } from './components/popups/vehiculos/galeria-nuevo-dispositivo/galeria-nuevo-dispositivo.component';
import { PortatilModalComponent } from './components/dialogos/portatiles/portatil-modal/portatil-modal.component';
import { PortatilUltimaTransmisionComponent } from './components/dialogos/portatiles/portatil-ultima-transmision/portatil-ultima-transmision.component';
import { HistoricoPosicionesPortatilesComponent } from './components/popups/portatiles/historico-posiciones-portatiles/historico-posiciones-portatiles.component';
import { InformacionPortatilComponent } from './components/popups/portatiles/informacion-portatil/informacion-portatil.component';
import { ModalImagenComponent } from '../mantenimiento/components/modal-imagen/modal-imagen.component';
import { PerfiloperadorComponent } from './components/popups/vehiculos/perfiloperador/perfiloperador.component';
import { UltimaTransmisionBotonCiudadanoComponent } from './components/dialogos/ultima-transmision-boton-ciudadano/ultima-transmision-boton-ciudadano.component';
import { BotonCiudadanoComponent } from './components/dialogos/boton-ciudadano/boton-ciudadano.component';
import { InformacionPanelComponent } from './components/popups/paneles/informacion-panel/informacion-panel.component';
import { HistoricoPanelComponent } from './components/popups/paneles/historico-panel/historico-panel.component';
import { HistoricoCombustibleComponent } from './components/popups/vehiculos/historico-combustible/historico-combustible.component';
import { GraficaHistoricoCombustibleComponent } from './components/popups/vehiculos/grafica-historico-combustible/grafica-historico-combustible.component';

@NgModule({
	declarations: [
		MonitoreoComponent,
		InformacionVehiculoComponent,
		HistoricoPosicionesVehiculoComponent,
		StreetViewComponent,
		PasoPuntoVehiculoComponent,
		HistorialVelocidadesVehiculoComponent,
		GaleriaVehiculoComponent,
		GraficaEstadisticaVehiculoComponent,
		InformacionMedidorComponent,
		HistoricoPosicionesMedidorComponent,
		GraficaEstadisticaMedidorComponent,
		InformacionMicromedidorComponent,
		VehiculoModalComponent,
		VehiculoUltimaTransmisionComponent,
		MedidorModalComponent,
		MedidorUltimaTransmisionComponent,
		MicromedidorModalComponent,
		MicromedidorUltimaTransmisionComponent,
		GuardarGeocercaComponent,
		GeocercaModalComponent,
		PuntosInteresModalComponent,
		GuardarPuntoInteresComponent,
		SemaforoModalComponent,
		InformacionActivoComponent,
		HistoricoPosicionesActivoComponent,
		ActivoModalComponent,
		ActivoUltimaTransmisionComponent,
		TelefonoModalComponent,
		TelefonoUltimaTransmisionComponent,
		HistoricoPosicionesTelefonoComponent,
		InformacionTelefonoComponent,
		AlertasComponent,
		GaleriaVideosComponent,
		SafeUrlPipe,
		PasoPuntoComponent,
		DentroGeocercaComponent,
		FueraGeocercaComponent,
		DentroGeocercaModalComponent,
		MapaMarkerComponent,
		PlayVideoComponent,
		StreamVideoComponent,
		PopupRecorridoHistoricoComponent,
		HistoricoMedicionesMicromedidorComponent,
		CategoriasComponent,
		ReproduccionComponent,
		FiltroProductosComponent,
		GaleriaNuevoDispositivoComponent,
		PortatilModalComponent,
		PortatilUltimaTransmisionComponent,
		HistoricoPosicionesPortatilesComponent,
		InformacionPortatilComponent,
		PerfiloperadorComponent,
		UltimaTransmisionBotonCiudadanoComponent,
		BotonCiudadanoComponent,
		InformacionPanelComponent,
		HistoricoPanelComponent,
		HistoricoCombustibleComponent,
		GraficaHistoricoCombustibleComponent,
	],

	imports: [
		CommonModule,
		MonitoreoRoutingModule,
		DxButtonModule,
		DxTemplateModule,
		DxDataGridModule,
		MatDividerModule,
		MatListModule,
		DxSelectBoxModule,
		DxCheckBoxModule,
		DxTreeListModule,
		MatDialogModule,
		DxFormModule,
		FormsModule,
		DxButtonModule,
		DxPopupModule,
		DxPopoverModule,
		DxDateBoxModule,
		DxLoadPanelModule,
		DxValidatorModule,
		DxValidationGroupModule,
		DxTagBoxModule,
		DxCircularGaugeModule,
		DxLinearGaugeModule,
		DxChartModule,
		DxTabPanelModule,
		DxTabsModule,
		SharedModule,
		ToastrModule.forRoot(),
		CdkStepperModule,
		CdkTableModule,
		CdkTreeModule,
		DragDropModule,
		GoogleChartsModule.forRoot(),
		MatCardModule,
		GaugeChartModule,
		NgxPermissionsModule,
		NgxChartsModule,
		NgbModalModule,
		ReutilizablesModule
	],

	providers: [
		DatePipe
	],

	entryComponents: [
		/**Popups vehiculos */
		InformacionVehiculoComponent,
		StreetViewComponent,
		PasoPuntoVehiculoComponent,
		HistorialVelocidadesVehiculoComponent,
		HistoricoPosicionesVehiculoComponent,
		GraficaEstadisticaVehiculoComponent,
		GaleriaVehiculoComponent,
		GaleriaVideosComponent,
		PasoPuntoComponent,
		DentroGeocercaComponent,
		FueraGeocercaComponent,
		DentroGeocercaModalComponent,
		MapaMarkerComponent,
		PlayVideoComponent,
		GaleriaNuevoDispositivoComponent,
		HistoricoCombustibleComponent,
		GraficaHistoricoCombustibleComponent,
		MapaMarkerComponent,
		/**Portatiles */
		PortatilModalComponent,
		PortatilUltimaTransmisionComponent,
		InformacionPortatilComponent,
		HistoricoPosicionesPortatilesComponent,
		/**Popups medidodres */
		InformacionMedidorComponent,
		HistoricoPosicionesMedidorComponent,
		GraficaEstadisticaMedidorComponent,
		/**Popuup micromedidores */
		InformacionMicromedidorComponent,
		HistoricoMedicionesMicromedidorComponent,

		/**Popups activos */
		InformacionActivoComponent,
		HistoricoPosicionesActivoComponent,

		/**Popups telefonos */
		InformacionTelefonoComponent,
		HistoricoPosicionesTelefonoComponent,

		/**Modales */
		VehiculoModalComponent,
		VehiculoUltimaTransmisionComponent,
		MedidorModalComponent,
		MedidorUltimaTransmisionComponent,
		MicromedidorModalComponent,
		MicromedidorUltimaTransmisionComponent,
		GeocercaModalComponent,
		GuardarGeocercaComponent,
		PuntosInteresModalComponent,
		GuardarPuntoInteresComponent,
		SemaforoModalComponent,
		ActivoModalComponent,
		ActivoUltimaTransmisionComponent,
		TelefonoModalComponent,
		TelefonoUltimaTransmisionComponent,
		AlertasComponent,
		StreamVideoComponent,
		CategoriasComponent,
		PopupRecorridoHistoricoComponent,
		ReproduccionComponent,
		FiltroProductosComponent,
		PerfiloperadorComponent,
		/**paneles */
		BotonCiudadanoComponent,
		UltimaTransmisionBotonCiudadanoComponent,
		InformacionPanelComponent,
		HistoricoPanelComponent
	]
})
export class MonitoreoModule { }
